import React from 'react';
import { useSelector } from 'react-redux';

export default function CtaSection() {
    const lang = useSelector((s) => s.system.lang || 'mn');
    const en = lang === 'en';

    return (
        <section className="relative py-20 lg:py-28 bg-brand-dark overflow-hidden">
            {/* Decorative pattern */}
            <div className="absolute inset-0 bg-grid-pattern opacity-40" />
            <div
                className="absolute inset-0 opacity-30"
                style={{
                    backgroundImage:
                        'repeating-linear-gradient(45deg, #F5C518 0, #F5C518 1px, transparent 1px, transparent 24px)',
                }}
            />

            {/* <div className="relative max-w-[1100px] mx-auto px-4 lg:px-8 text-center">
                <h2
                    className="font-heading uppercase font-bold text-white leading-[1.1] tracking-tight"
                    style={{ fontSize: 'clamp(1.9rem, 1.2rem + 2.8vw, 3.8rem)' }}
                >
                    {en
                        ? 'We are building the future of Mongolia’s energy'
                        : 'Бид Монголын эрчим хүчний ирээдүйг бүтээж байна'}
                </h2>
                <div className="mx-auto mt-8 h-1 w-24 bg-brand-yellow" />
            </div> */}
        </section>
    );
}